export default __webpack_public_path__ + "static/media/examsSchool.d09bc662.svg";